
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class QuotationBOMGrid extends Serenity.EntityGrid<QuotationBOMRow, any> {
        protected getColumnsKey() { return 'Purchase.QuotationBOM'; }
        protected getDialogType() { return QuotationBOMDialog; }
        protected getIdProperty() { return QuotationBOMRow.idProperty; }
        protected getInsertPermission() { return QuotationBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return QuotationBOMRow.localTextPrefix; }
        protected getService() { return QuotationBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}